import { isEqual } from 'lodash-es';
import { ReactNode } from 'react';


const isEqualSorted = (a1 = [], a2 = []) => isEqual(a1.sort(), a2.sort());
const fromComaString = (val = '') => Array.isArray(val) ? val : (val === '' ? [] : val.split(','));
const toComaString = (array: unknown[] = []) => array.sort().join(',');
const toComaNotSortedString = (array = []) => array.join(',');
const joinJSX = (list: ReactNode[], separator: ReactNode = null) =>
  list?.length ? list.reduce((prev, curr) => ([] as ReactNode[]).concat(prev, separator, curr)) : null;

const ensureArray = <T>(data: T | T[]) => Array.isArray(data) ? data : [data];

const prefillArray = (length: number, getValue: () => unknown) => {
  return [...new Array(length)].map(getValue);
};

const Arrays = {
  isEqualSorted,
  fromComaString,
  toComaString,
  toComaNotSortedString,
  joinJSX,
  ensureArray,
  prefillArray
};

export default Arrays;
